export const event2behavior = {
  'item@click': 'onClick',
  'item@dblclick': 'onDblClick',
  'item@mouseover': 'onHover',
  'item@mouseout': 'onUnHover',
  'item@mousedown': 'onPress',
  'item@contextmenu': 'onContextMenu',
  mousedown: 'onMouseDown',
  mousemove: 'onMouseMove',
  mouseup: 'onMouseUp',
  click: 'onNoopClick',
};
